import EventStatus from "./EventStatus";

import moment from "moment";

export default ({ event, onClickEvent, bigText = false }) => {
  //console.log("EVENT", event);

  return (
    <div
      className={`slot-event-card-simple ${event.timeStart === -1 ? "slot-event-card-simple-fullday" : ""} ${bigText ? "slot-event-card-simple-big-text" : ""}`}
      style={
        event.timeStart === -1 ? { backgroundColor: event.calendarColor } : {}
      }
      onClick={(e) => {
        e.stopPropagation();
        onClickEvent(event);
      }}
    >
      <EventStatus status={event.status} />
      <span style={{}}>
        {event.timeStart !== -1 && (
          <span style={{ color: event.calendarColor }}>
            {moment(event.timeStart, "HH:mm:ss").format("HH:mm")} -{" "}
          </span>
        )}
        {event.subject}
        {event.patient.id !== -1 && (
          <span>
            {" - " + event.patient.name + " " + event.patient.lastName}
          </span>
        )}
      </span>
    </div>
  );
};
